import { IEmailSetting } from '@/types/components/email';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

const emailSettingInitial: IEmailSetting = {
  sender: '',
  accentColour: "#000000",
  logo: '',
  isVerifyEmail: false,
  isEnableReadyForPickup: false,
  isEnableOutForDelivery: false,
  isErrorEmail: false,
};

const initialState = {
    email: {
        emailSetting: emailSettingInitial,
    },
    emailBackup: {
        emailSetting: emailSettingInitial,
    },
};

const emailSlice = createSlice({
  name: 'emailSetting',
  initialState,
  reducers: {
    handleSaveEmailSettings: (state, action: PayloadAction<Partial<IEmailSetting>>) => {
      const updated = {
        ...state.email.emailSetting,
        ...action.payload,
      };
    
      const backup = state.emailBackup.emailSetting;
    
      const fieldsChange = Object.fromEntries(
        Object.keys(state.emailBackup.emailSetting)
          .filter((key) => key !== 'fieldsChange')
          .filter((key) => {
            const typedKey = key as keyof IEmailSetting;
            return JSON.stringify(updated[typedKey]) !== JSON.stringify(backup[typedKey]);
          })
          .map((key) => {
            const typedKey = key as keyof IEmailSetting;
            return [typedKey, updated[typedKey]];
          })
      );
      
    
      state.email.emailSetting = {
        ...updated,
        fieldsChange,
      };
    },    
    handleSaveEmailBackupSettings: (state, action: PayloadAction<Partial<IEmailSetting>>) => {
        state.emailBackup.emailSetting = { ...state.emailBackup.emailSetting, ...action.payload };
    },
    handleResetEmailSetting: (state) => {
        state.email.emailSetting = state.emailBackup.emailSetting;
    },
  },
});

export const emailSettingSelector = createSelector(
  (state: RootState) => state.email,
  (state) => state.email.emailSetting,
);

export const emailBackupSettingSelector = createSelector(
  (state: RootState) => state.email,
  (state) => state.emailBackup.emailSetting,
);

export const { handleSaveEmailSettings, handleSaveEmailBackupSettings, handleResetEmailSetting } = emailSlice.actions;

export default emailSlice;
